module.exports = __webpack_public_path__ + "static/media/helmet_polyline.38944b2e.gif";